import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import { quickSearchByQuery } from '@vue-storefront/core/lib/search'
import config from 'config' // Add this import

import { ActionTree } from 'vuex'

import { ProductsState } from '../types/ProductsState'
import * as types from './mutation-types'

import {
  productsQuery,
  productQuery
} from '../queries'

export const actions: ActionTree<ProductsState, any> = {
  async setProducts({ commit }, { start, size }) {
    const { storeCode } = currentStoreView()
    start = start || 0
    size = size || 500
    return quickSearchByQuery({ query: productsQuery, storeCode, start, size })
      .then((response) => commit(types.SET_PRODUCTS, response.items))
  },
  async setProduct({ commit }, { sku }) {
    const { storeCode } = currentStoreView()
    return quickSearchByQuery({ query: productQuery({ sku }), storeCode })
      .then((response) => commit(types.SET_PRODUCT, response.items[0]))
  },
  async setLastReleasedProducts({ commit }) {
    const url = `${config.products.last_released_endpoint}`;
    try {
      const response = await fetch(`${url}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })

      if (!response.ok) {
        throw new Error('Failed to fetch released products')
      }

      const data = await response.json()
      commit(types.SET_RELEASED_PRODUCTS, data.result || [])
      return data.result || []
    } catch (error) {
      console.error('Error fetching released products:', error)
      return []
    }
  }
}
